import SQLEditor from "./SQLEditor";
import SQLOutput from "./SQLOutput";
import SQLProblem from "./SQLProblem";
import SplitPane from "react-split-pane";
import React, { useContext } from "react";
import Pane from "react-split-pane/lib/Pane";
import { useLocation } from "react-router-dom";
import AlertContext from "../../../context/AlertContext";
import CodingSplitHooks from "../../../Hooks/CodingPage/CodingSplitHooks";

export default function SQLSplit() {
  const Alert = useContext(AlertContext);

  const {
    heightFind,
    verticalSize,
    handleProblem,
    outputWindowHeight,
    toggleOutputWindowHeight,
  } = CodingSplitHooks();

  const { pathname } = useLocation();

  return (
    <SplitPane
      minSize={50}
      split="vertical"
      primary="second"
      size={verticalSize}
      onChange={handleProblem}
      className="codingpageVerticalSplitPane"
    >
      {!Alert.isFullScreen && (
        <Pane
          minSize="304px"
          maxSize="504px"
          initialSize={verticalSize}
          className={
            !pathname.includes("library")
              ? "sqlProblemPane"
              : "sqlProblemPaneForLibrary"
          }
        >
          <SQLProblem />
        </Pane>
      )}
      <SplitPane
        split="horizontal"
        onChange={heightFind}
        className="codingpageHorizontalSplitPane"
      >
        <Pane
          className={
            !Alert.theme ? "codingEditorPane" : "codingEditorPaneDarkTheme"
          }
        >
          <SQLEditor />
        </Pane>
        {!Alert.isFullScreen && (
          <Pane className="codingOutputPane" initialSize={outputWindowHeight}>
            <SQLOutput toggleOutputWindowHeight={toggleOutputWindowHeight} />
          </Pane>
        )}
      </SplitPane>
    </SplitPane>
  );
}
